export default class HttpHelper {
	static GetEncodeText(text: string): string {
		return text.replace('?', '%3F').replace('&', '%26').replace('#', '%23').replace('/', '-')
	}
}
